export default __webpack_public_path__ + "static/media/magnetic-chess-set.1d439f6b.webp";